var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"u-flex u-leading-body vs__dropdown-option__item",on:{"click":_vm.onClick}},[_c('span',{staticClass:"vs__dropdown-option__value"},[_vm._v(_vm._s(_vm.optionDisplayValue))]),(_vm.isSelected)?_c('i',{staticClass:"u-ml-auto u-flex u-pt-2p"},[_c('IconCheck')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }